import React from "react";
import { BiChevronDown } from "react-icons/bi";

import s from "./Select.module.css";

const Select = ({
  options,
  groups,
  value,
  onChange,
  name,
  placeholder = "Select",
  small = false,
  disabled = false,
  fullWidth = false,
  error = false,
  ariaRequired = false,
}) => {
  const handleChange = (event) => {
    event.persist();
    onChange(event.target.value);
  };

  const isObjectOptions =
    options &&
    typeof options.at(0)?.value !== "undefined" &&
    options.at(0)?.label;

  const renderOption = (option) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  );

  return (
    <div
      className={`${s.container} ${fullWidth ? s.fullWidth : ""}`}
      style={{ height: small ? "36px" : "48px" }}
      disabled={disabled}
    >
      <select
        className={`${s.select} ${error ? s.selectError : ""}`}
        name={name}
        style={{
          height: small ? "36px" : "48px",
          padding: small ? "4px 30px 4px 12px" : "12px 30px 12px 12px",
        }}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        aria-required={ariaRequired ? "true" : undefined}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {groups
          ? groups.map((group) => (
              <optgroup key={group.label} label={group.label}>
                {group.options.map(renderOption)}
              </optgroup>
            ))
          : isObjectOptions
            ? options.map(renderOption)
            : options &&
              options.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
      </select>
      <div className={s.icon}>
        <BiChevronDown />
      </div>
    </div>
  );
};

export { Select };
